import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {HelpInfoSearch} from '../../../models/help-info-search.interface';

@Component({
  selector: 'app-dialogs-filter',
  templateUrl: './dialogs-filter.component.html',
  styleUrls: ['./dialogs-filter.component.scss']
})
export class DialogsFilterComponent implements OnInit {

  searchForm = this.formBuilder.group({
    code: [''],
    title: [''],
  });

  get codeControl(): FormControl {
    return this.searchForm.get('code') as FormControl;
  }
  get titleControl(): FormControl {
    return this.searchForm.get('title') as FormControl;
  }

  @Output()
  search: EventEmitter<HelpInfoSearch> = new EventEmitter<HelpInfoSearch>();

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
  }

  handleSubmit(): void {
    const dto: HelpInfoSearch = {
      code: this.codeControl.value,
      title: this.titleControl.value
    };
    this.search.emit(dto);
  }

  clean(): void {
    this.search.emit({});
  }


}
